package pl.decks.chartjs.radar.options

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.model.JSScriptable

data class TickOptions(
    val display: Boolean = true,
    val color: JSScriptable<ChartColor>? = null,
    val backdropColor: JSScriptable<ChartColor>? = null,
    val stepSize: Float? = null,
    val count: Int? = null,
    val maxTicksLimit: Int? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.display = display.asDynamic()
        if (color != null) this.color = color.toChartJs { it.toChartJs() }
        if (backdropColor != null) this.backdropColor = backdropColor.toChartJs { it.toChartJs() }
        if (stepSize != null) this.stepSize = stepSize.asDynamic()
        if (count != null) this.count = count.asDynamic()
        if (maxTicksLimit != null) this.maxTicksLimit = maxTicksLimit.asDynamic()
    }
}
